const types = {
  SET_ACTION_LIST: 'SET_ACTION_LIST',
  SET_ACTION_DETAILS: 'SET_ACTION_DETAILS',
  SET_ACTION: 'SET_ACTION',
  SET_SMS_MESSAGE_LINK: 'SET_SMS_MESSAGE_LINK',
  SET_SMS_MESSAGE: 'SET_SMS_MESSAGE',
  SET_SMS_SUBJECT: 'SET_SMS_SUBJECT',
  SET_REPLYS: 'SET_REPLYS',
  SET_EMAIL_SUBJECT: 'SET_EMAIL_SUBJECT',
  SET_EMAIL_FROM: 'SET_EMAIL_FROM',
  SET_TEST_NPS_REVIEW: 'SET_TEST_NPS_REVIEW',
  SET_ALERT_RULES: 'SET_ALERT_RULES',
  SET_KEYWORD_RULES: 'SET_KEYWORD_RULES',
  SET_QUARENTINE: 'SET_QUARENTINE',
  SET_LIST_ID: 'SET_LIST_ID',
  SET_NPS_BY_ACTION: 'SET_NPS_BY_ACTION',
  SET_ACTION_WORD_CLOUD: 'SET_ACTION_WORD_CLOUD',
  SET_ACTION_UPLOADED_IMAGE: 'SET_ACTION_UPLOADED_IMAGE',
  SET_ACTION_QUESTION: 'SET_ACTION_QUESTION',
  SET_ALL_ACTIONS: 'SET_ALL_ACTIONS',
  SET_ACTIONS_IDS: 'SET_ACTIONS_IDS',
  SET_ALL_ACTION_GROUPS: 'SET_ALL_ACTION_GROUPS',
};

export default types;



// WEBPACK FOOTER //
// ./src/store/modules/actions/mutations-types.js